export default __webpack_public_path__ + "static/media/iconProductTag.13fba5e2.svg";